import { render, staticRenderFns } from "./newyearP2.vue?vue&type=template&id=630d61f8&scoped=true&"
import script from "./newyearP2.vue?vue&type=script&lang=js&"
export * from "./newyearP2.vue?vue&type=script&lang=js&"
import style0 from "./newyearP2.vue?vue&type=style&index=0&id=630d61f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d61f8",
  null
  
)

export default component.exports